<template lang="pug">
v-app
  div(v-if="$store.state.user")
    NavBar
    router-view.ml-14.mt-16(@update_nav="update_nav($event)")
  div(v-else)
    Config
</template>
<script>
import NavBar from "./components/NavBar"
import Config from "./components/ConfigIp.vue"
export default {

  components:{NavBar, Config},
  data() {
    return {
      drawerOpen: false,
      navcontent:"jjj",
    }
  },
  methods:{
    update_nav(html) {
      this.navcontent = html
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

p {
  text-align: left;
  margin: 10px;
}
nav {
  a {
    font-weight: bold;
    color: white !important;
    text-decoration:none;
  }
}
</style>
